import { render } from "./ImportButton.vue?vue&type=template&id=f760347e&scoped=true"
import script from "./ImportButton.vue?vue&type=script&lang=js"
export * from "./ImportButton.vue?vue&type=script&lang=js"

import "./ImportButton.vue?vue&type=style&index=0&id=f760347e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f760347e"]])

export default __exports__